module.exports = __webpack_public_path__ + "img/female.1064c564.svg";